import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseCrmSalesforceList, RCrmSalesforceList} from './crmSalesforceListModel';

/*
 * Runtime type.
 */

const RCrmSyncSearchSalesforceListsDirty = t.readonly(
  t.type({
    limit: t.union([t.Integer, t.undefined]),
    hasMore: t.union([t.boolean, t.undefined]),
    lists: t.readonlyArray(RCrmSalesforceList),
  }),
);

/*
 * Type.
 */

export interface CrmSyncSearchSalesforceListsModel
  extends t.TypeOf<typeof RCrmSyncSearchSalesforceListsDirty> {}
export const RCrmSyncSearchSalesforceLists = t.clean<CrmSyncSearchSalesforceListsModel>(
  RCrmSyncSearchSalesforceListsDirty as any,
);

/*
 * IO methods.
 */

export function parseCrmSyncSearchSalesforceLists(src: any): CrmSyncSearchSalesforceListsModel {
  return {
    lists: src.lists && src.lists.map(parseCrmSalesforceList),
    limit: src.limit,
    hasMore: Boolean(src.has_more),
  };
}

/*
 * API type.
 */

export const ApiCrmSyncSearchSalesforceLists = makeApiType(
  'crmSyncSearchSalesforceLists',
  RCrmSyncSearchSalesforceLists,
  parseCrmSyncSearchSalesforceLists,
);
